module.exports = __webpack_public_path__ + "static/media/E2.bf88c87.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/E2.mp4
// module id = Of8+
// module chunks = 8